<template>
  <div v-if="currentRoles.name === '广告管理'" class="page-index ad-index">
    <div class="toolbar-box">
      <el-button v-if="currentRoles.roles['广告管理-新增']" class="btn-left" size="mini" @click="openModel">添加广告</el-button>
      <div style="flex:1"></div>
      <el-select v-if="userInfo.companyList.length > 0" class="search-input2" multiple collapse-tags v-model="query.companyIds" @change="seach" placeholder="请选择公司">
        <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
       <el-select class="search-input" v-model="status" @change="seach">
        <el-option label="上架中" value="0"></el-option>
        <el-option label="下架中" value="1"></el-option>
      </el-select>
      <el-input  class="search-input" v-model="query.query" @keyup.enter.native="seach" placeholder="请输入广告标题" />
    </div>
    <el-table
        ref="table"
        :data="list"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
       <el-table-column
          header-align="center"
          align="center"
          type="index"
          :index="indexMethod"
          width="50"
          label="#">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="150"
          prop="title"
          label="标题">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          label="所属公司">
        <template slot-scope="scope">
          <div>{{scope.row.company.name}}</div>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="192"
          label="顶部图片">
        <template slot-scope="scope">
          <el-image :src="scope.row.topCoverPath" fit="fill"></el-image>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="topUrl"
          width="200"
          label="顶部图片url">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="192"
          label="底部图片">
        <template slot-scope="scope">
          <el-image :src="scope.row.bottomCoverPath" fit="fill"></el-image>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="bottomUrl"
          width="200"
          label="底部图片url">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="startDate"
          width="100"
          label="上架时间">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="endDate"
          width="100"
          label="下架时间">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 0">已上架</div>
          <div v-if="scope.row.status === 1">已下架</div>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="180"
          label="操作">
        <template slot-scope="scope">
          <div v-if="scope.row.editer">
            <div v-if="currentRoles.roles['广告管理-上下架']" style="display:inline-block;margin-right:10px;">
              <el-tooltip v-if="scope.row.status === 0" content="下架" placement="top">
                <el-button size="mini" @click.stop="handleSwitch(scope.row)" title="下架">
                  <i class="icon el-icon-disable"></i>
                </el-button>
              </el-tooltip>
              <el-tooltip v-if="scope.row.status === 1" content="上架" placement="top">
                <el-button size="mini" @click.stop="handleSwitch(scope.row)" title="上架">
                  <i class="icon el-icon-enable"></i>
                </el-button>
              </el-tooltip>
            </div>
            <el-tooltip v-if="currentRoles.roles['广告管理-编辑']" content="编辑" placement="top">
              <el-button size="mini" @click.stop="openModel2(scope.row)">
                <i class="icon el-icon-edit"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip v-if="currentRoles.roles['广告管理-删除']" content="删除" placement="top">
              <el-button size="mini" @click.stop="handleDelete(scope.row)">
                <i class="icon el-icon-delete"></i>
              </el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>

    <el-dialog
        title="添加广告"
        :visible.sync="dialogVisible"
        width="650px"
        :before-close="handleClose">
      <el-form ref="advmanage" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="标题" prop="title">
          <el-input placeholder="请输入标题" v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="公司" prop="companyId">
          <el-select v-model="form.companyId" placeholder="请选择公司">
            <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="顶部图片" prop="topCover">
          <!-- <upload-image-cropper ref="topImg"></upload-image-cropper> -->
          <upload-image-cropper v-if="dialogVisible" ref="topImg" :fixedNumber="[3.84, 1]" width="384" height="100"></upload-image-cropper>
          <div style="font-size：12px;color:red;">*注：图片大小为384*100</div>
        </el-form-item>
        <el-form-item label="顶部图片链接">
          <el-input placeholder="请输入顶部图片链接" v-model="form.topUrl"></el-input>
        </el-form-item>
        <el-form-item label="底部图片" prop="bottomCover">
          <!-- <upload-image-cropper ref="bottomImg"></upload-image-cropper> -->
          <upload-image-cropper v-if="dialogVisible" ref="bottomImg" :fixedNumber="[3.84, 1]" width="384" height="100"></upload-image-cropper>
          <div style="font-size：12px;color:red;">*注：图片大小为384*100</div>
        </el-form-item>
        <el-form-item label="底部图片链接">
          <el-input placeholder="请输入顶部图片链接" v-model="form.bottomUrl"></el-input>
        </el-form-item>
        <el-form-item label="上架日期" prop="startDate">
          <el-date-picker v-model="form.startDate" type="date" placeholder="选择上架日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="下架日期" prop="endDate">
          <el-date-picker v-model="form.endDate" type="date" placeholder="选择下架日期"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="修改广告"
        :visible.sync="dialogVisible2"
        width="650px"
        :before-close="handleClose">
      <el-form ref="advmanage2" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="标题" prop="title">
          <el-input placeholder="请输入标题" v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="顶部图片">
          <el-image style="width: 384px; height: 100px" :src="form.topCoverPath" fit="fill"></el-image>
        </el-form-item>
        <el-form-item label="顶部图片链接">
          <el-input placeholder="请输入顶部图片链接" v-model="form.topUrl"></el-input>
        </el-form-item>
        <el-form-item label="底部图片">
          <el-image style="width: 384px; height: 100px" :src="form.bottomCoverPath" fit="fill"></el-image>
        </el-form-item>
        <el-form-item label="底部图片链接">
          <el-input placeholder="请输入顶部图片链接" v-model="form.bottomUrl"></el-input>
        </el-form-item>
        <el-form-item label="上架日期" prop="startDate">
          <el-date-picker v-model="form.startDate" type="date" placeholder="选择上架日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="下架日期" prop="endDate">
          <el-date-picker v-model="form.endDate" type="date" placeholder="选择下架日期"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import UploadImageCropper from '../../components/upload-image-cropper/upload-image-cropper'
  import { formatDate, dateDiff } from '../../utils/common'
  import { apiUpload } from '../../api/file'
  import { apiEdit, apiDelete, apiDetail, apiGetList, apiSwitch } from '../../api/adv'

  export default {
    mixins: [tableMixin],
    name: 'system',
    data() {
      return {
        dialogVisible: false,
        dialogVisible2: false,
        list: [],
        pageIndex: 1,
        total: 0,
        query: {
          query: '',
          companyIds: []
        },
        status: '0',
        form: {},
        rules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur' },
            { max: 50, message: '长度在 50 个字符之内', trigger: 'blur' }
          ],
          companyId: [
            { required: true, message: '请选择公司', trigger: 'change' }
          ],
          topCover: [
            { required: true, message: '请选择顶部图片', trigger: 'change' }
          ],
          topUrl: [
            { required: true, message: '请输入顶部链接', trigger: 'blur' },
            { max: 255, message: '长度在 255 个字符之内', trigger: 'blur' }
          ],
          bottomCover: [
            { required: true, message: '请选择底部图片', trigger: 'change' }
          ],
          bottomUrl: [
            { required: true, message: '请输入底部链接', trigger: 'blur' },
            { max: 255, message: '长度在 255 个字符之内', trigger: 'blur' }
          ],
          startDate: [
            { required: true, message: '请选择上架日期', trigger: 'change' }
          ],
          endDate: [
            { required: true, message: '请选择下架日期', trigger: 'change' }
          ]
        }
      }
    },
    components: {
      UploadImageCropper
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      this._getList()
    },
    methods: {
      // 打开model
      openModel() {
        this.dialogVisible = true
        this.form = {
          title: '',
          companyId: '',
          topCover: '',
          topUrl: '',
          bottomCover: '',
          bottomUrl: '',
          startDate: new Date(),
          endDate: new Date()
        }
        if (this.userInfo.companyList.length === 1) {
          this.form.companyId = this.userInfo.companyList[0].id
        }
        if (this.$refs['advmanage']) {
          this.$refs['advmanage'].resetFields()
        }
      },
      openModel2(row) {
        this.dialogVisible2 = true
        this.form = {
          id: row.id,
          title: row.title,
          companyId: row.companyId,
          topCoverPath: row.topCoverPath,
          topUrl: row.topUrl,
          bottomCoverPath: row.bottomCoverPath,
          bottomUrl: row.bottomUrl,
          startDate: row.startDate,
          endDate: row.endDate
        }
        if (this.$refs['advmanage2']) {
          this.$refs['advmanage2'].resetFields()
        }
      },
      // 关闭对话框
      handleClose() {
        this.$confirm('确认关闭？').then(_ => {
          this.dialogVisible = false
          this.dialogVisible2 = false
        }).catch(_ => {})
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      indexMethod(index) {
        return (this.pageIndex - 1) * 20 + index + 1
      },
      // 搜索
      seach() {
        this.pageIndex = 1
        this._getList()
      },
      // 获取列表
      _getList(pageIndex = 1) {
        apiGetList(this.query, this.status, pageIndex).then(data => {
          data.data.data.forEach(item => {
            let index = -1
            if (this.userInfo.companyIds) {
              index = this.userInfo.companyIds.split(',').indexOf(item.companyId + '')
            }
            if (index > -1) {
              item.editer = true
            } else {
              item.editer = false
            }
          })
          this.list = data.data.data
          this.total = data.data.total
        })
      },
      // 上下架
      handleSwitch(row) {
        let msg = '下架成功'
        if (row.status === 1) {
          msg = '上架成功'
        }
        apiSwitch(row.id).then(() => {
          this.$message({
            type: 'success',
            message: msg
          })
          this._getList()
        })
      },
      // 新增
      handleAdd() {
        let day = dateDiff(this.form.endDate, this.form.startDate)
        if (!(day >= 0)) {
          this.$message({
            type: 'warning',
            message: '结束日期不能在开始日期之前'
          })
          return
        }
        if (this.$refs.topImg.file) {
          this.form.topCover = this.$refs.topImg.file.name
        }
        if (this.$refs.bottomImg.file) {
          this.form.bottomCover = this.$refs.bottomImg.file.name
        }
        this.$refs['advmanage'].validate((valid) => {
          if (valid) {
            let param1 = new FormData()
            param1.append('file', this.$refs.topImg.file.raw, this.$refs.topImg.file.name)
            apiUpload(param1).then(data1 => {
              this.form.topCover = data1.data
              let param2 = new FormData()
              param2.append('file', this.$refs.bottomImg.file.raw, this.$refs.bottomImg.file.name)
              apiUpload(param2).then(data2 => {
                this.form.bottomCover = data2.data
                this.form.startDate = formatDate(this.form.startDate, 'YYYY-MM-DD')
                this.form.endDate = formatDate(this.form.endDate, 'YYYY-MM-DD')
                apiEdit(this.form).then(() => {
                  this.$message({
                    type: 'success',
                    message: '新增成功'
                  })
                  this.dialogVisible = false
                  this._getList()
                })
              })
            })
          }
        })
      },
      // 编辑
      handleEdit() {
        let day = dateDiff(this.form.endDate, this.form.startDate)
        if (!(day >= 0)) {
          this.$message({
            type: 'warning',
            message: '结束日期不能在开始日期之前'
          })
          return
        }
        this.$refs['advmanage2'].validate((valid) => {
          if (valid) {
            this.form.startDate = formatDate(this.form.startDate, 'YYYY-MM-DD')
            this.form.endDate = formatDate(this.form.endDate, 'YYYY-MM-DD')
            apiEdit(this.form).then(() => {
              this.$message({
                type: 'success',
                message: '修改成功'
              })
              this.dialogVisible2 = false
              this._getList()
            })
          }
        })
      },
      // 删除
      handleDelete(row) {
        this.$confirm(`是否删除广告：${row.title}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiDelete(row.id).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this._getList()
          })
        })
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.ad-index
    .btn-left
      background #A5CE1C
      color #fff
    .toolbar-box
      display flex
      margin 10px 0
      .search-input
        width 150px
      .search-input2
        margin-right 10px
    .el-form-item__content
      width 200px
</style>
